/**
 * Appends a per-build version token to remote image URLs so a redeploy busts
 * stale browser/CDN caches. Product/restaurant photos live at fixed Firebase
 * Storage URLs; replacing an image at the same path leaves the URL unchanged,
 * so returning browsers serve old bytes. Relative/bundled assets (already
 * content-hashed by Vite) and data:/blob: URLs are left untouched.
 */
const BUILD_ID = typeof __BUILD_ID__ !== "undefined" ? __BUILD_ID__ : "dev";

export const withImageVersion = (url?: string | null): string | undefined => {
  if (!url) return url ?? undefined;
  if (!/^https?:\/\//i.test(url)) return url; // skip bundled/relative assets
  return `${url}${url.includes("?") ? "&" : "?"}v=${BUILD_ID}`;
};
